<template>
  <div class="chat-area">
      <!-- <div class="chat-container"> -->
        <Chat v-if="!minimized"
        v-bind:key="activity"
        :activity="activity"
        :myself="chatMyself"
        :other="chatOther"
        :messages="messages"
        :colors="colors"
        :hide-close-button="hideCloseButton"
        :submit-icon-size="submitIconSize"
        :load-more-messages="toLoad.length > 0 ? loadMoreMessages : null"
        :scroll-bottom="scrollBottom"
        :display-header="true"
        :other-typing="this.otherTyping"
        @onMessageSubmit="onMessageSubmit"
        @onClose="onClose"
        @onMinimize="onMinimize"
        @onTyping="onTyping"/>
      <div v-else @click="openChat()" class="chat-minimized" :class="{'missed': missedMessages > 0}">
          <span v-if="missedMessages > 0">{{missedMessages}}</span>
          <img src="https://hearo-remote-supports.imgix.net/hearoassets/hrs_uploads%2F704ad881-be74-4405-95d7-4662cf9c4568.png?w=100" alt="open chat with Hearo Support"/>
      </div>
   </div>
</template>
<script>
import Chat from './ChatComponent.vue'
import 'vue-quick-chat/dist/vue-quick-chat.css'
import PubNub from 'pubnub'
import PubnubConfig from '../pubnubConfig'

import { mapState } from 'vuex'

export default {
    components: {
        Chat
    },
    data() {
        return {
            otherTyping: false,
            minimized: false,
            missedMessages: 0,
            timeout: null,
            lastActive: null,
            available: true,
            inactive: false,
            userId: "",
            chatOther: {},
            chatParticipants: [],
            pubnub: null,
            chatOpen: false,
            chatMyself: {
                name: '',
                isAdmin: false,
                id: '',
                profilePic: ''
            },
            messages: [],
            colors: {
                header: {
                    bg: '#3DBA84',
                    text: '#fff'
                },
                message: {
                    myself: {
                        bg: '#fff',
                        text: '#000'
                    },
                    others: {
                        bg: '#DFF0E5',
                        text: '#000'
                    },
                    messagesDisplay: {
                        bg: '#f7f3f3'
                    }
                },
                submitIcon: '#3DBA84',
            },
            hideCloseButton: true,
            submitIconSize: 25,
            toLoad: [],
            scrollBottom: {
                messageSent: true,
                messageReceived: false
            },
            displayHeader:true,
        }
    },
     computed:  {
        ...mapState({
            pubChannel: state => state.pubChannel,
            participants: state => state.participants,
        }),
        activity() {
            return {
                available: this.available,
                // inactive: this.inactive
            }
        }
    },
    async mounted() {
        this.userId = window.userId
        // this.lastActive = new Date()
        window.addEventListener('chat-participants-localstorage-changed', (event) => {
            this.chatParticipants = JSON.parse(event.detail.participants)
            this.$store.commit('setPubChannel', event.detail.channel)
            this.initPubnub()
            this.hideCloseButton = !this.chatMyself.isAdmin
            this.checkPreviousMessages()
            const alreadyMinimized = window.localStorage.getItem('chat-minimized')
            if(alreadyMinimized == 'true') {
                this.minimized = true
                const missedMessages = window.localStorage.getItem('chat-missed-messages')
                if(missedMessages && parseInt(missedMessages) > 0) {
                    this.missedMessages = parseInt(missedMessages)
                }
            } else if (this.messages <= 1) {
                this.openChat()
            }
            // this.sendInactivityMessage(false)
        })
    },
    watch: {
        // lastActive() {
        //     if(!this.chatMyself.isAdmin){
        //         // if I'm currently inactive, but I'm getting this lastActive change... then I'm active.
        //         if(this.inactive) {
        //             this.inactive = false
        //         }
        //         if (this.timeout) { clearTimeout(this.timeout) }
        //         this.timeout = setTimeout(function () { this.sendInactivityMessage(true) }.bind(this), 60000)
        //     }
        // },
        chatParticipants() {
            this.addParticipants()
        },
        // chatOpen() {
        //     this.lastActive = new Date()
        // },
    },
    methods: {
        publishMessage(message){
            this.lastActive = new Date()
            var publishPayload = {
                channel : this.pubChannel,
                message: {
                    type: "message",
                    payload: message,
                }
            }
            this.pubnub.publish(publishPayload, function() {
                // console.log('publish response', status, response)
            })
        },
        initPubnub() {
            this.messages = []
            this.pubnub = new PubNub({
                publishKey:  PubnubConfig.CONFIG.publishKey,
                subscribeKey: PubnubConfig.CONFIG.subscribeKey,
                uuid: 'chat_' + this.userId
            })
            this.pubnub.subscribe({
                channels: [this.pubChannel]
            })
            this.pubnub.addListener({
                status: (statusEvent) => {
                    if (statusEvent.category === "PNConnectedCategory") {
                        // console.log('category event')
                    }
                },
                message: (msg) => {
                    switch (msg.message.type) {
                    case 'message':
                        this.messages.push(msg.message.payload)
                        if(msg.message.payload.participantId != this.chatMyself.id) {
                            this.otherTyping = false;
                            this.playAlert()
                        } else {
                            this.playSend()
                        }
                        if(this.minimized) {
                            this.missedMessages++
                            window.localStorage.setItem('chat-missed-messages', this.missedMessages)
                        }
                        // this.chatOpen = true
                        break
                    case 'logout':
                        if(this.chatMyself.isAdmin){
                        this.available = false
                        } else {
                            this.onClose()
                            alert("The HEARO admin you were chatting with has logged off. If you would like to contact HEARO directly, please add a support ticket and we will get back with you as soon as possible.")
                        }
                        break
                    case 'inactivity':
                        this.inactive = msg.message.payload.inactive
                        break
                    case 'typing':
                        if(msg.message.payload.participant !== this.chatMyself.id) {
                            this.otherTyping = msg.message.payload.typing
                        }
                        break
                    default:
                        console.log(`message type ${msg.message.type} not applicable.`)
                    }
                }
            })
        },
        addParticipants() {
            this.$store.commit('setParticipants', this.chatParticipants)
            // cloning so I don't mess with the initial
            const allparticipants = this.chatParticipants
            allparticipants.map(p => {
                if(p.id === window.userId) {
                    this.chatMyself = p
                    this.$store.commit('saveMyself', p)
                } else {
                    this.chatOther = p
                    this.$store.commit('saveOther', p)
                }
            })
        },
        onMessageSubmit: function (message) {
            this.publishMessage(message)
        },
        onClose() {
                 var publishPayload = {
                    channel : "User_" + this.chatOther.id,
                    message: {
                        type: "CloseMessage",
                        payload: "Test",
                    }
                }
                this.pubnub.publish(publishPayload, function() {
                    // console.log(status, response)
                })
            
                this.resetData()
                window.dispatchEvent(new CustomEvent('hearo-user-closed-window'))
           
        },
        resetData() {
            this.pubChannel = ""
            this.messages = []
            this.chatParticipants = []
            this.available = true
            this.minimized = true
            this.chatOpen = false
        },
        onMinimize() {
            // this.sendInactivityMessage(false)
            this.minimized = true
            this.chatOpen = false
            window.localStorage.setItem('chat-minimized', true)
        },
        onTyping(value) {
             var publishPayload = {
                channel : this.pubChannel,
                message: {
                    type: "typing",
                    payload: {
                        participant: this.chatMyself.id,
                        typing: value
                    },
                }
            }
            this.pubnub.publish(publishPayload, function() {
                // console.log(status, response)
            })
        },
        openChat() {
            this.missedMessages = 0
            window.localStorage.setItem('chat-missed-messages', 0)
            this.minimized = false
            this.chatOpen = true
            window.localStorage.setItem('chat-minimized', false)
        },
        async checkPreviousMessages() {
            const prevMessages = await this.pubnub.fetchMessages(
                {
                    channels: [this.pubChannel],
                    stringifiedTimeToken: true,
                    includeMeta: true,
                    includeMessageActions: true,
            }
            )
            const parsed = JSON.parse(JSON.stringify(prevMessages))
            const messagesArray = parsed.channels[Object.keys(parsed.channels)[0]]
            if(messagesArray) {
                const messageMessages = messagesArray.filter(m => m.message.type == 'message')
                this.messages = messageMessages.map(m => m.message.payload)
            }
        },
        checkOccupancy() {
            this.pubnub.hereNow(
                {
                    channels: [this.pubChannel],
                },
                function (status, response) {
                    const parsed = JSON.parse(JSON.stringify(response))
                    if(parsed) {
                        return parsed.totalOccupancy >=2
                    }
                    return false
                }
            )
        },
        playAlert() {
            const audio = new Audio(`/audio/chat_alert.mp3`)
            audio.play()
        },
        playSend() {
            const audio = new Audio(`/audio/chat_send.mp3`)
            audio.play()
        },
        sendInactivityMessage() {
            // console.log('sending inactivity message: ', state)
        //     this.inactive = state
        //     const payload = {
        //         lastActive: this.lastActive,
        //         inactive: this.inactive
        //     }
        //      var publishPayload = {
        //         channel : this.pubChannel,
        //         message: {
        //             type: "inactivity",
        //             payload: payload,
        //         }
        //     }
        //    this.pubnub.publish(publishPayload, function(status, response) {
        //         console.log('publish response', status, response)
        //     })
        }
    }
}
</script>